module.exports = __webpack_public_path__ + "img/scrollLogo.eeab2362.png";